import { forwardRef } from 'react'
import { IconElement, IconProps } from 'types/ui'

export const PlusIcon: IconElement = forwardRef((props: IconProps, ref) => {
  return (
    <svg ref={ref} viewBox='0 0 16 16' fill='none' className={props.className}>
      <path
        d='M6.87085 6.87085V2H9.12915V6.87085H14V9.12915H9.12915V14H6.87085V9.12915H2V6.87085H6.87085Z'
        fill='currentColor'
      />
    </svg>
  )
})

PlusIcon.displayName = 'PlusIcon'
